/** Preferences-window diagnostics through the renderer log pipeline (见 15). */
function settingsWindowLog(
  level: 'error' | 'warn',
  message: string,
  data?: Record<string, unknown>,
): void {
  const hibroLog = (
    globalThis as {
      hibroLog?: {
        append: (entry: {
          level: string;
          kind: string;
          message: string;
          error?: unknown;
        }) => void;
      };
    }
  ).hibroLog;
  hibroLog?.append({
    level,
    kind: 'log',
    message,
    ...(data ? { error: data } : {}),
  });
}

export function settingsWindowLogError(
  message: string,
  data?: Record<string, unknown>,
): void {
  settingsWindowLog('error', message, data);
}

export function settingsWindowLogWarn(
  message: string,
  data?: Record<string, unknown>,
): void {
  settingsWindowLog('warn', message, data);
}
